import { Pipe, PipeTransform } from '@angular/core';
import { AbstractControl, FormControl } from '@angular/forms';

@Pipe({
    name: 'dTypeFormControl',
    pure      : false,
    standalone: true,
})
export class GetFormControlPipe implements PipeTransform {

    transform(value: AbstractControl, name: string): FormControl {
        return (value.get(name) as FormControl) ?? new FormControl();
    }

}
